import React from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import AccountsReport from './AccountsReport';

const AccountsReportIndex = () => {
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Reporte de Cuentas Contables</h3>
                    <br />
                </Col>
            </Row>
            <Row>
                <Card>
                    <CardBody>
                        <AccountsReport />
                    </CardBody>
                </Card>
            </Row>
        </Container>
    );
}

export default AccountsReportIndex;
